import React, { useEffect, useState } from 'react'
import { CartesianGrid, Bar, BarChart, Legend, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts'
import _ from 'lodash';


function ConversationMetrics({ metricsData }) {

    const [barData, setBarData] = useState(null)
    const [uniqueEmotions, setUniqueEmotions] = useState(null)


    const emotionColors = {
        joy: '#FFD700',      // Gold
        sadness: '#4682B4',  // Steel Blue
        anger: '#FF4500',    // Red Orange
        fear: '#800080',     // Purple
        disgust: '#228B22',  // Forest Green
        surprise: '#FF69B4'  // Hot Pink
    };

    // Group and transform data for stacked bars
    function transformDataToStackedBarChart(data) {

        const data_x = {}

        data.forEach((item1, idx, self) => {
            const x1 = self.filter((item2) => {

                return item1.timestamp === item2.timestamp
            })

            data_x[item1.timestamp] = x1
        })

        const new_data = []
        for (const [key, values] of Object.entries(data_x)) {
            const entry = {
                "timestamp": key
            };
            values.forEach(item => {
                entry[item.dominant_emotion] = item.emotion_score
            })

            new_data.push(entry)
        }

        const sortedDataByDate = new_data.sort((a, b) => {
            return new Date(a.timestamp) - new Date(b.timestamp)
        })

        return sortedDataByDate
    }




    useEffect(() => {
        // Get unique emotions for creating bars
        const unique = _.uniq(metricsData.map(item => item.dominant_emotion));

        setBarData(transformDataToStackedBarChart(metricsData))
        setUniqueEmotions(unique)

    }, [metricsData])

    return (
        <div className="text-black">
            <h2 className="text-lg font-semibold mb-4">Emotion Scores</h2>
            {barData &&
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart
                        data={barData}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 30,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="timestamp" />
                        <YAxis />
                        <Tooltip
                            formatter={(value, name) => [
                                value ? value.toFixed(3) : '0',
                                name.charAt(0).toUpperCase() + name.slice(1)
                            ]}
                        />
                        <Legend />
                        {uniqueEmotions.map((emotion) => (
                            <Bar
                                key={emotion}
                                dataKey={emotion}
                                name={emotion.charAt(0).toUpperCase() + emotion.slice(1)}
                                stackId="stack"
                                fill={emotionColors[emotion]}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            }
        </div>
    );
}

export default ConversationMetrics
